export function formatDate(timestamp, { includeYear = true } = {}) {
  if (!timestamp) return '';
  const d = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  const options = { month: 'short', day: 'numeric' };
  if (includeYear) options.year = 'numeric';
  return d.toLocaleDateString('en-US', options);
}
